// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#vue-component[data-v-03be8182]{display:block}#vue-component .main #links[data-v-03be8182]{margin:30px 0 30px}#vue-component .main #links a[data-v-03be8182]{padding:10px;display:inline-block;width:75px;text-align:center}#vue-component .main #links a.router-link-exact-active[data-v-03be8182]{background-color:#007bff;color:#fff;border-radius:4px}", ""]);
// Exports
module.exports = exports;
